import { render, staticRenderFns } from "./TextDropdownField.vue?vue&type=template&id=045062a9&"
import script from "./TextDropdownField.vue?vue&type=script&lang=js&"
export * from "./TextDropdownField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports